export default {
  selectedInstitution(state) {
    return state.selectedInstitution
  },
  company(state) {
    return state.company
  },
  domain(state) {
    return state.domain
  },
  productUrls(state) {
    return state.productUrls
  },
  productKeywords(state) {
    return state.productKeywords
  },
  specialInstructions(state) {
    return state.specialInstructions
  },
  rerunReport(state) {
    return state.rerunReport
  }
}
